import { Brand, getBrand } from '@/brand/brand'
import { Http } from '@/network/http'
import { Urls } from '@/network/urls'
import { appVersion } from '@/service/env'

const generateRandomMac = () => {
  let mac = ''
  for (let i = 0; i < 6; i++) {
    mac += Math.floor(Math.random() * 256)
      .toString(16)
      .padStart(2, '0')
    if (i < 5) {
      mac += ':'
    }
  }
  return mac
}
const getMacAddress = () => {
  const mac = localStorage.getItem('mac')
  if (mac) {
    return mac
  } else {
    const randomMac = generateRandomMac()
    localStorage.setItem('mac', randomMac)
    return randomMac
  }
}

export const trackUserActivity = () => {
  const key = 'lastActiveDate'
  const item = localStorage.getItem(key)
  const today = new Date().toISOString().split('T')[0] // 获取当天日期字符串
  if (item !== today) {
    localStorage.setItem(key, today)
    sendActivityToServer()
  }
}

const sendActivityToServer = async () => {
  const data = {
    version_code: appVersion(),
    operation_type: 'day_active',
    mac: getMacAddress(),
    from: 'hid_web',
  }

  const bd = await getBrand()
  let host = 'https://irok.ast.joyway.net'
  if (bd == Brand.iyx) {
    host = 'https://ncus.iyx.fun'
  } else if (bd == Brand.carotmas) {
    host = 'https://ncus.carotmas.com'
  }

  Http.post(Urls.ping, data, host).catch((error) => console.error('Error sending activity to server:', error))
}

export const trackEvent = async (type: string) => {
  const data = {
    version_code: appVersion(),
    operation_type: type,
    mac: getMacAddress(),
    from: 'hid_web',
  }

  const bd = await getBrand()
  let host = 'https://irok.ast.joyway.net'
  if (bd == Brand.iyx) {
    host = 'https://ncus.iyx.fun'
  } else if (bd == Brand.carotmas) {
    host = 'https://ncus.carotmas.com'
  }
  console.log('trackEvent', data)

  Http.post(Urls.ping, data, host).catch((error) => console.error('Error sending event to server:', error))
}
